import { useQuery } from '@apollo/client';
import {
  MEU_EXTRATO_FINANCEIRO,
  MeuExtratoFinanceiroData,
  MeuExtratoFinanceiroVars,
} from '../services/financeiroService';
import type { ExtratoLinha, PeriodoFinanceiro, TipoExtratoLinha } from '../types/financeiro';

// Hook do bloco Pendências (financeiro-dashboard-atleta Phase 4, Task 8 do plano; AC-A4) —
// consulta PRÓPRIA, não derivada da página carregada do extrato: uma pendência que caia na
// página 3 do extrato precisa aparecer no topo do hub do mesmo jeito, e filtrar `items` em
// memória a esconderia.
//
// `tipos` é restrito a INSCRICAO/AGENDAMENTO (não só `status`) porque os 3 enums de status se
// sobrepõem: PENDENTE existe em StatusPagamento E em StatusReembolso. Sem restringir `tipos`, um
// pedido de reembolso PENDENTE (aguardando decisão da liga, não algo que o atleta deva pagar)
// entraria na lista de "o que eu devo pagar". ABERTO/AGUARDANDO_PAGAMENTO só existem em
// StatusPedidoAgendamento e são descartados pela fonte de inscrição (Task 3 do backend), o que
// deixa a mesma lista de status servir às duas fontes restantes sem precisar de duas consultas.

const TIPOS_COM_PENDENCIA: TipoExtratoLinha[] = ['INSCRICAO', 'AGENDAMENTO'];
const STATUS_EM_ABERTO = ['PENDENTE', 'ABERTO', 'AGUARDANDO_PAGAMENTO'];

export interface UsePendenciasFinanceirasResult {
  pendencias: ExtratoLinha[];
  loading: boolean;
  error: Error | undefined;
}

export function usePendenciasFinanceiras(periodo: PeriodoFinanceiro): UsePendenciasFinanceirasResult {
  const query = useQuery<MeuExtratoFinanceiroData, MeuExtratoFinanceiroVars>(MEU_EXTRATO_FINANCEIRO, {
    variables: {
      filtro: periodo,
      tipos: TIPOS_COM_PENDENCIA,
      status: STATUS_EM_ABERTO,
      page: 0,
      size: 20,
    },
    fetchPolicy: 'no-cache',
  });

  return {
    pendencias: query.data?.meuExtratoFinanceiro?.items ?? [],
    loading: query.loading,
    error: query.error,
  };
}
